import React, { Component } from 'react';
import { connect } from 'react-redux';
import StationList from '../StationList';
import { fetchStations } from '../../stations';

const mapDispatchToProps = dispatch => ({
  actions: {
    fetchStations: () => dispatch(fetchStations('')),
  },
});

const mapStateToProps = state => ({
  ...state.stations,
});

class StationListContainer extends Component {
  componentDidMount() {
    const { actions } = this.props;
    actions.fetchStations();
  }

  render() {
    const { stations } = this.props;
    return <StationList stations={stations} />;
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(StationListContainer);
